var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.property)?_c('div',{staticClass:"code"},[_c('b',[_vm._v(_vm._s(_vm.property.$.Name))]),_vm._v(" : "+_vm._s(_vm.property.$.Type)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }